export default __webpack_public_path__ + "static/media/logo-viasat-group.23047a69.png";